<mat-dialog-content>
  <h2 class="text-2xl mb-6" i18n>Create activity</h2>
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="min-w-96 grid gap-6">
    <div>
      <app-autocomplete-staff formControlName="staff"></app-autocomplete-staff>
      @if (form.controls.staff.hasError("duplicate")) {
        <mat-error
          class="px-4 mat-mdc-form-field-subscript-wrapper mat-mdc-form-field-error"
          i18n
        >
          This person already has an activity here.
        </mat-error>
      }
    </div>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label i18n>Contract Type</mat-label>
      <mat-select formControlName="type">
        <!-- Required so the custom option content doesn't show up in the trigger -->
        <mat-select-trigger>
          {{
            getContractTypeTriggerText
              | apply: (form.controls.type | valueChanges)
          }}
        </mat-select-trigger>
        @for (contractType of contractTypes; track contractType.value) {
          <!-- Some piping to make sure we avoid as many change detection cycles
                as possible and only call the `checkEligibility` observable
                factory when the staff form control changes value -->
          @if (
            checkEligibility
              | apply: (form.controls.staff | valueChanges) : contractType.value
              | async;
            as eligibility
          ) {
            <mat-option
              [value]="contractType.value"
              [disabled]="!eligibility.eligible"
            >
              {{ contractType.title }}
              @if (!eligibility.eligible) {
                <div class="text-sm text-gray-700">
                  {{ eligibility.reason }}
                </div>
              }
            </mat-option>
          }
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label i18n>Role</mat-label>
      <mat-select formControlName="role">
        <!-- Required so the custom option content doesn't show up in the trigger -->
        <mat-select-trigger>
          {{
            getActivityRoleTriggerText
              | apply: (form.controls.role | valueChanges)
          }}
        </mat-select-trigger>
        @for (role of activityRoles; track role.value) {
          <mat-option [value]="role.value">
            {{ role.title }}
            @if (role.remarks; as remarks) {
              <div class="text-xs text-red-900 flex">
                <mat-icon inline>priority_high</mat-icon>
                <div>
                  @if (remarks.notApplied) {
                    <div i18n>Did not apply for this role</div>
                  }
                  @if (remarks.notOpen) {
                    <div i18n>No open position for this role</div>
                  }
                </div>
              </div>
            }
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <app-hourly-pay-form-field
      formControlName="hourlyPay"
      [class.!hidden]="
        (form.controls.type.valueChanges | async) === ContractType.GeenContract
      "
      [staff]="form.controls.staff | valueChanges"
      [role]="form.controls.role | valueChanges"
      [target]="dialogData.target"
      (onAutoChange)="this.automaticWage.set($event)"
    ></app-hourly-pay-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>
        <span i18n>Hours</span>
        <mat-icon matTooltip="Calculated from the schedule" i18n-matTooltip>
          contact_support
        </mat-icon>
      </mat-label>
      <input matInput type="number" formControlName="hours" />
    </mat-form-field>

    @if (
      overlappingActivities()?.length && overlappingActivities();
      as overlappingActivities
    ) {
      <app-admonition i18n>
        The proposed activity overlaps, please select which activity is the main
        activity from which the contract and payments will be derived:
      </app-admonition>
      <app-main-activity-picker
        [activities]="overlappingActivities"
        (onMainActivityChanged)="selectedMainActivity.set($event)"
      ></app-main-activity-picker>
    }

    <div class="grid grid-cols-2 gap-4">
      <button class="button button-danger" mat-dialog-close i18n>Cancel</button>
      <button
        class="button"
        type="submit"
        data-cy="submit"
        [disabled]="!form.valid || !overlappingActivities()"
        i18n
      >
        Submit
      </button>
    </div>
  </form>
</mat-dialog-content>
